module.exports = "https://r.zoocdn.com/_next/static/images/hero-image-large-e4afd5fd8d0e52ac6629dfc149d2208a.jpg";